import React from 'react';
import { string, object } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './CardTypeB.css';

const CardTypeB = ({ title, icon, info }) => (
  <div className={styles.card}>
    <Icon customClasses={styles.icon} {...icon} />
    <p className={styles.title}>{title}</p>
    <p className={styles.info}>{info}</p>
  </div>
);

CardTypeB.propTypes = {
  title: string,
  icon: object,
  info: string
};

CardTypeB.displayName = 'CardCardTypeB';

export default CardTypeB;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/CardBanner/Cards/CardTypeB/CardTypeB.js